import {Component} from '@angular/core';
import {NavController, NavParams, ToastController, LoadingController} from 'ionic-angular';
import {SenhaProvider} from '../../providers/senha/senha.provider';

/**
 * Esqueci minha senha (ECOENEL-343): etapa 1 envia código de 6 dígitos por e-mail,
 * etapa 2 valida o código e define a nova senha. Mesmas regras do WebGestor.
 */
@Component({
  selector: 'page-esqueci-senha',
  templateUrl: 'esqueci-senha.html',
})
export class EsqueciSenhaPage {
  etapa: 'email' | 'codigo' = 'email';
  email: string = '';
  codigo: string = '';
  senha: string = '';
  senhaConfirmacao: string = '';
  mostrarSenha: boolean = false;
  validadeMinutos: number = 30;

  requisitos = SenhaProvider.REQUISITOS;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private toastCtrl: ToastController,
              private loadingCtrl: LoadingController,
              private senhaProvider: SenhaProvider) {}

  atende(requisito: any): boolean {
    return requisito.testa(this.senha || '');
  }

  get senhaValida(): boolean {
    return this.requisitos.every(r => this.atende(r));
  }

  get podeRedefinir(): boolean {
    return this.codigo.length === 6 && this.senhaValida && this.senha === this.senhaConfirmacao;
  }

  limparCodigo() {
    this.codigo = (this.codigo || '').replace(/\D/g, '').slice(0, 6);
  }

  solicitarCodigo(reenvio: boolean = false) {
    if (!this.email || !this.email.trim()) {
      this.toast('Informe seu e-mail.');
      return;
    }

    const loading = this.loadingCtrl.create({content: 'Enviando código...'});
    loading.present();

    this.senhaProvider.solicitarCodigo(this.email.trim())
      .then(res => {
        loading.dismiss();
        this.validadeMinutos = (res && res.validade_minutos) || this.validadeMinutos;
        this.etapa = 'codigo';
        if (reenvio) {
          this.toast('Um novo código foi enviado. O código anterior deixou de valer.');
        }
      })
      .catch(msg => {
        loading.dismiss();
        this.toast(msg);
      });
  }

  redefinir() {
    if (this.codigo.length !== 6) {
      this.toast('Informe o código de 6 dígitos recebido por e-mail.');
      return;
    }
    if (!this.senhaValida) {
      this.toast('A senha não atende a todos os requisitos.');
      return;
    }
    if (this.senha !== this.senhaConfirmacao) {
      this.toast('As senhas não conferem.');
      return;
    }

    const loading = this.loadingCtrl.create({content: 'Redefinindo senha...'});
    loading.present();

    this.senhaProvider.redefinir({
      email: this.email.trim(),
      codigo: this.codigo,
      senha: this.senha,
      senha_confirmacao: this.senhaConfirmacao,
    })
      .then(res => {
        loading.dismiss();
        this.toast(res.success || 'Senha redefinida com sucesso!', 3000);
        this.navCtrl.pop();
      })
      .catch(msg => {
        loading.dismiss();
        this.toast(msg, 3500);
      });
  }

  trocarEmail() {
    this.etapa = 'email';
    this.codigo = '';
  }

  private toast(mensagem: string, duracao: number = 2500) {
    this.toastCtrl.create({message: mensagem, duration: duracao, position: 'top'}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/esqueci-senha/esqueci-senha.ts